module.exports = __webpack_public_path__ + "img/badminton.206dec32.jpg";